module.exports = __webpack_public_path__ + "img/banner1.de2cb339.png";